import { render } from "./DocumentEdit.vue?vue&type=template&id=0ecba500&scoped=true"
import script from "./DocumentEdit.vue?vue&type=script&lang=js"
export * from "./DocumentEdit.vue?vue&type=script&lang=js"

import "../../assets/scss/document_edit.scss?vue&type=style&index=0&id=0ecba500&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecba500"]])

export default __exports__